module.exports = __webpack_public_path__ + "static/media/devchallenges.9370464c.svg";